import React from 'react';
import PropTypes from 'prop-types';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

const PhdHelpHint = ({ label, title }) => (
  <Tooltip title={title} trigger={['hover', 'focus', 'click']}>
    <button
      type="button"
      aria-label={label}
      style={{
        alignItems: 'center',
        background: 'transparent',
        border: 0,
        color: 'inherit',
        cursor: 'help',
        display: 'inline-flex',
        marginInlineStart: 4,
        padding: 2,
      }}
    >
      <InfoCircleOutlined aria-hidden="true" />
    </button>
  </Tooltip>
);

PhdHelpHint.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
};

export default PhdHelpHint;
